import type { ICommissionItemAttributeBaseSchema } from '@modules/affiliate-program-commissions/submodules/edit/types';
import type { VFormFilterButtonProps, VFormFilterButtonType } from '@modules/form-widgets/components/VFormFilterButton/types';
import type { FormSchema } from '@modules/forms/components/VForm/types';
import {
  createOptionalGuard,
  isNumber,
  isString,
  isValidInterface,
} from '@utils/guards';

export interface VFormFilterButtonWithFormProps<TSchema> {
  formSchema: FormSchema<TSchema>;
  value?: TSchema;
  valueSuffix?: string;
  label?: string;
  type?: VFormFilterButtonType;
}

export interface VFormFilterButtonWithForm<TSchema>
  extends VFormFilterButtonProps,
  VFormFilterButtonWithFormProps<TSchema> {
}

export interface VFormButtonsWithFormGroupWidgetProps<TSchema> {
  buttons: VFormFilterButtonWithForm<TSchema>[];
  addButton?: VFormFilterButtonWithFormProps<TSchema>;
  formTitle?: string;
  formSubmitBtn?: string;
  formCloseBtn?: string;
  label?: string;
  errors?: string[];
  readonly?: boolean;
  flexDirectionColumn?: boolean;
}

export interface VFormButtonsWithFormGroupWidgetEmits<TSchema> {
  (e: 'change', index: number, value: TSchema): void;
  (e: 'input', index: number | string, value: TSchema): void;
  (e: 'add', value: TSchema): void;
  (e: 'remove', index: number): void;
}

export function isStepItemGuard(value: unknown): value is ICommissionItemAttributeBaseSchema {
  return isValidInterface(value, {
    obtained_result: isString,
    condition_for_comparison: isString,
    desired_value: createOptionalGuard(isNumber),
  }, { silent: true });
}
